// 사용자 Event에 대한 처리 유틸
import store from '@/store'
import envs from '@/envs'

let DEBUG_MODE = !!envs.framework.showDetailLog
let PREFIX = {
  START: '[UI START]',
  INFO: '[UI]'
}

let logger = {
  init(Vue) {
    // 초기화
    if (DEBUG_MODE) console.log('=== Global Logging Info ===')
    if (DEBUG_MODE) console.log('navigator.userAgent:', navigator.userAgent)
    store.dispatch('SetAgentType')
    // 전체 Click Event 처리
    document.addEventListener('click', function(e) {
      if (DEBUG_MODE) console.log('GLOBAL:', e.target)
      // 일반 버튼 클릭 시 처리 이벤트
      if (e.target.type === 'button') {
        if (DEBUG_MODE) {
          console.log('Button Action ID:', e.target.dataset.actionId)
        }
        if (DEBUG_MODE) console.log('Currnet Menu Name:', store.state.log.name)
      }
    })

    // Vue 내부에서 발생한 에러 캐치
    Vue.config.errorHandler = function(err, vm, info) {
      console.error(err)
    }
  },
  // 로딩 간 로딩 내역 출력 전용
  start(...logParams) {
    if (!DEBUG_MODE) return
    console.log(PREFIX.START, ...logParams)
  },
  info(...logParams) {
    if (!DEBUG_MODE) return
    console.log(PREFIX.INFO, ...logParams)
  },
  // 메뉴 혹은 화면이 변경되었을 경우 실행 됨
  changeView(to) {
    // let currentMenu = _.find(store.state.menu.menus, { href: to.path })
    // if (!currentMenu) currentMenu = to.name
    // else currentMenu = currentMenu.menu_id
    // console.log('Viewing:', to.path, currentMenu)
    store.dispatch('SetCurrnetRoute', to)
  }
}

export default logger
